module.exports = __webpack_public_path__ + "static/media/nhp_personality.8b31653f.png";